// LoginScreen.jsx
/*
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from './logo.png';

const API_URL = `${process.env.REACT_APP_API_URL}/api/auth`;

function LoginScreen() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };
// LoginScreen.jsx
const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');

  if (!formData.username || !formData.password) {
    setError('Please enter both username and password');
    return;
  }

  setLoading(true);

  try {
    const response = await fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (data.success) {
      // Store user info in localStorage (NO TOKEN)
      localStorage.setItem('userId', data.data.userId);
      localStorage.setItem('username', data.data.username);
      localStorage.setItem('isLoggedIn', 'true');
      
      // Redirect to admin dashboard
      navigate('/admin-dashboard');
    } else {
      setError(data.message || 'Login failed');
    }
  } catch (err) {
    console.error('Login error:', err);
    setError('Network error. Please try again.');
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F1419 0%, #1A1F2E 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'clamp(1rem, 3vw, 2rem)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        top: '-10%',
        right: '-10%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(199, 179, 129, 0.08) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-10%',
        left: '-10%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(199, 179, 129, 0.05) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>

      <div style={{
        width: '100%',
        maxWidth: '480px',
        background: 'rgba(15, 20, 25, 0.95)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(199, 179, 129, 0.2)',
        borderRadius: '16px',
        padding: isMobile ? 'clamp(2rem, 5vw, 3rem)' : 'clamp(2.5rem, 5vw, 3.5rem)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ textAlign: 'center', marginBottom: 'clamp(2rem, 4vw, 3rem)' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
            <img 
              src={logo} 
              alt="ST Motors Logo" 
              style={{
                height: 'clamp(60px, 10vw, 80px)',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </Link>
          <h1 style={{
            fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
            fontWeight: '300',
            color: '#FFFFFF',
            marginBottom: '0.5rem',
            letterSpacing: '-0.01em'
          }}>
            Welcome <span style={{ fontWeight: '600', color: '#C7B381' }}>Back</span>
          </h1>
          <p style={{
            fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
            color: '#B8B8B8',
            fontWeight: '300'
          }}>
            Sign in to access your dashboard
          </p>
        </div>

        {error && (
          <div style={{
            background: 'rgba(220, 53, 69, 0.1)',
            border: '1px solid rgba(220, 53, 69, 0.3)',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '1.5rem',
            color: '#ff6b6b',
            fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
              color: '#C7B381',
              marginBottom: '0.5rem',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase'
            }}>
              Username
            </label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter username"
              autoComplete="username"
              style={{
                width: '100%',
                padding: 'clamp(0.9rem, 2vw, 1.1rem)',
                background: 'rgba(26, 31, 46, 0.6)',
                border: '1px solid rgba(199, 179, 129, 0.2)',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                color: '#FFFFFF',
                outline: 'none',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#C7B381';
                e.target.style.background = 'rgba(26, 31, 46, 0.8)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                e.target.style.background = 'rgba(26, 31, 46, 0.6)';
              }}
            />
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <label style={{
              display: 'block',
              fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
              color: '#C7B381',
              marginBottom: '0.5rem',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase'
            }}>
              Password
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
                autoComplete="current-password"
                style={{
                  width: '100%',
                  padding: 'clamp(0.9rem, 2vw, 1.1rem)',
                  paddingRight: '3rem',
                  background: 'rgba(26, 31, 46, 0.6)',
                  border: '1px solid rgba(199, 179, 129, 0.2)',
                  borderRadius: '8px',
                  fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                  color: '#FFFFFF',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  fontFamily: 'inherit'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#C7B381';
                  e.target.style.background = 'rgba(26, 31, 46, 0.8)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                  e.target.style.background = 'rgba(26, 31, 46, 0.6)';
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '1rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#C7B381',
                  cursor: 'pointer',
                  fontSize: '1.2rem'
                }}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 'clamp(1rem, 2vw, 1.25rem)',
              background: loading ? 'rgba(199, 179, 129, 0.5)' : 'linear-gradient(135deg, #C7B381 0%, #A89968 100%)',
              color: '#0F1419',
              border: 'none',
              borderRadius: '8px',
              fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
              fontWeight: '600',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 16px rgba(199, 179, 129, 0.3)'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(199, 179, 129, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 16px rgba(199, 179, 129, 0.3)';
            }}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

      </div>
    </div>
  );
}

export default LoginScreen;*/

// LoginScreen.jsx
/*
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from './logo.png';

const API_URL = `${process.env.REACT_APP_API_URL}/api/auth`;

function LoginScreen() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };
// LoginScreen.jsx
const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');

  if (!formData.username || !formData.password) {
    setError('Please enter both username and password');
    return;
  }

  setLoading(true);

  try {
    const response = await fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (data.success) {
      // Store user info in localStorage (NO TOKEN)
      localStorage.setItem('userId', data.data.userId);
      localStorage.setItem('username', data.data.username);
      localStorage.setItem('isLoggedIn', 'true');
      
      // Redirect to admin dashboard
      navigate('/admin-dashboard');
    } else {
      setError(data.message || 'Login failed');
    }
  } catch (err) {
    console.error('Login error:', err);
    setError('Network error. Please try again.');
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F1419 0%, #1A1F2E 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'clamp(1rem, 3vw, 2rem)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        top: '-10%',
        right: '-10%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(199, 179, 129, 0.08) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-10%',
        left: '-10%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(199, 179, 129, 0.05) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>

      <div style={{
        width: '100%',
        maxWidth: '480px',
        background: 'rgba(15, 20, 25, 0.95)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(199, 179, 129, 0.2)',
        borderRadius: '16px',
        padding: isMobile ? 'clamp(2rem, 5vw, 3rem)' : 'clamp(2.5rem, 5vw, 3.5rem)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ textAlign: 'center', marginBottom: 'clamp(2rem, 4vw, 3rem)' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
            <img 
              src={logo} 
              alt="ST Motors Logo" 
              style={{
                height: 'clamp(60px, 10vw, 80px)',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </Link>
          <h1 style={{
            fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
            fontWeight: '300',
            color: '#FFFFFF',
            marginBottom: '0.5rem',
            letterSpacing: '-0.01em'
          }}>
            Welcome <span style={{ fontWeight: '600', color: '#C7B381' }}>Back</span>
          </h1>
          <p style={{
            fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
            color: '#B8B8B8',
            fontWeight: '300'
          }}>
            Sign in to access your dashboard
          </p>
        </div>

        {error && (
          <div style={{
            background: 'rgba(220, 53, 69, 0.1)',
            border: '1px solid rgba(220, 53, 69, 0.3)',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '1.5rem',
            color: '#ff6b6b',
            fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
              color: '#C7B381',
              marginBottom: '0.5rem',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase'
            }}>
              Username
            </label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter username"
              autoComplete="username"
              style={{
                width: '100%',
                padding: 'clamp(0.9rem, 2vw, 1.1rem)',
                background: 'rgba(26, 31, 46, 0.6)',
                border: '1px solid rgba(199, 179, 129, 0.2)',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                color: '#FFFFFF',
                outline: 'none',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#C7B381';
                e.target.style.background = 'rgba(26, 31, 46, 0.8)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                e.target.style.background = 'rgba(26, 31, 46, 0.6)';
              }}
            />
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <label style={{
              display: 'block',
              fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
              color: '#C7B381',
              marginBottom: '0.5rem',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase'
            }}>
              Password
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
                autoComplete="current-password"
                style={{
                  width: '100%',
                  padding: 'clamp(0.9rem, 2vw, 1.1rem)',
                  paddingRight: '3rem',
                  background: 'rgba(26, 31, 46, 0.6)',
                  border: '1px solid rgba(199, 179, 129, 0.2)',
                  borderRadius: '8px',
                  fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                  color: '#FFFFFF',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  fontFamily: 'inherit'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#C7B381';
                  e.target.style.background = 'rgba(26, 31, 46, 0.8)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                  e.target.style.background = 'rgba(26, 31, 46, 0.6)';
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '1rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#C7B381',
                  cursor: 'pointer',
                  fontSize: '1.2rem'
                }}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 'clamp(1rem, 2vw, 1.25rem)',
              background: loading ? 'rgba(199, 179, 129, 0.5)' : 'linear-gradient(135deg, #C7B381 0%, #A89968 100%)',
              color: '#0F1419',
              border: 'none',
              borderRadius: '8px',
              fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
              fontWeight: '600',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 16px rgba(199, 179, 129, 0.3)'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(199, 179, 129, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 16px rgba(199, 179, 129, 0.3)';
            }}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

      </div>
    </div>
  );
}

export default LoginScreen;*/
// LoginScreen.jsx

/*
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from './logo.png';

const API_URL = process.env.REACT_APP_API_URL;

function LoginScreen() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.username || !formData.password) {
      setError('Please enter both username and password');
      return;
    }

    setLoading(true);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10s timeout

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
  },
  body: JSON.stringify(formData),
  signal: controller.signal,
  mode: 'cors',
});

      clearTimeout(timeoutId);

      const data = await response.json();

      if (data.success) {
        // Store minimal user info
        localStorage.setItem('userId', data.data.userId);
        localStorage.setItem('username', data.data.username);
        localStorage.setItem('isLoggedIn', 'true');

        navigate('/admin-dashboard');
      } else {
        setError(data.message || 'Login failed. Please check your credentials.');
      }
    } catch (err) {
      clearTimeout(timeoutId);
      if (err.name === 'AbortError') {
        setError('Request timed out. Please try again.');
      } else {
        console.error('Login error:', err);
        setError('Network error or server unavailable. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F1419 0%, #1A1F2E 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'clamp(1rem, 3vw, 2rem)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        top: '-10%',
        right: '-10%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(199, 179, 129, 0.08) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-10%',
        left: '-10%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(199, 179, 129, 0.05) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>

      <div style={{
        width: '100%',
        maxWidth: '480px',
        background: 'rgba(15, 20, 25, 0.95)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(199, 179, 129, 0.2)',
        borderRadius: '16px',
        padding: isMobile ? 'clamp(2rem, 5vw, 3rem)' : 'clamp(2.5rem, 5vw, 3.5rem)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ textAlign: 'center', marginBottom: 'clamp(2rem, 4vw, 3rem)' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
            <img 
              src={logo} 
              alt="ST Motors Logo" 
              style={{
                height: 'clamp(60px, 10vw, 80px)',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </Link>
          <h1 style={{
            fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
            fontWeight: '300',
            color: '#FFFFFF',
            marginBottom: '0.5rem',
            letterSpacing: '-0.01em'
          }}>
            Welcome <span style={{ fontWeight: '600', color: '#C7B381' }}>Back</span>
          </h1>
          <p style={{
            fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
            color: '#B8B8B8',
            fontWeight: '300'
          }}>
            Sign in to access your dashboard
          </p>
        </div>

        {error && (
          <div style={{
            background: 'rgba(220, 53, 69, 0.1)',
            border: '1px solid rgba(220, 53, 69, 0.3)',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '1.5rem',
            color: '#ff6b6b',
            fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
              color: '#C7B381',
              marginBottom: '0.5rem',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase'
            }}>
              Username
            </label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter username"
              autoComplete="username"
              required
              style={{
                width: '100%',
                padding: 'clamp(0.9rem, 2vw, 1.1rem)',
                background: 'rgba(26, 31, 46, 0.6)',
                border: '1px solid rgba(199, 179, 129, 0.2)',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                color: '#FFFFFF',
                outline: 'none',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#C7B381';
                e.target.style.background = 'rgba(26, 31, 46, 0.8)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                e.target.style.background = 'rgba(26, 31, 46, 0.6)';
              }}
            />
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <label style={{
              display: 'block',
              fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
              color: '#C7B381',
              marginBottom: '0.5rem',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase'
            }}>
              Password
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
                autoComplete="current-password"
                required
                style={{
                  width: '100%',
                  padding: 'clamp(0.9rem, 2vw, 1.1rem)',
                  paddingRight: '3rem',
                  background: 'rgba(26, 31, 46, 0.6)',
                  border: '1px solid rgba(199, 179, 129, 0.2)',
                  borderRadius: '8px',
                  fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                  color: '#FFFFFF',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  fontFamily: 'inherit'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#C7B381';
                  e.target.style.background = 'rgba(26, 31, 46, 0.8)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                  e.target.style.background = 'rgba(26, 31, 46, 0.6)';
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                style={{
                  position: 'absolute',
                  right: '1rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#C7B381',
                  cursor: 'pointer',
                  fontSize: '1.2rem'
                }}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 'clamp(1rem, 2vw, 1.25rem)',
              background: loading ? 'rgba(199, 179, 129, 0.5)' : 'linear-gradient(135deg, #C7B381 0%, #A89968 100%)',
              color: '#0F1419',
              border: 'none',
              borderRadius: '8px',
              fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
              fontWeight: '600',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 16px rgba(199, 179, 129, 0.3)'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(199, 179, 129, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 16px rgba(199, 179, 129, 0.3)';
            }}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginScreen;*/

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from './firebase';
import logo from './logo.png';

const API_URL = process.env.REACT_APP_API_URL;

const ALLOWED_GOOGLE_EMAILS = [
  'arjunmongar45@gmail.com',
  'marketing@sangaytsheltrim.com'
];

function LoginScreen() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.username || !formData.password) {
      setError('Please enter both username and password');
      return;
    }

    setLoading(true);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
        },
        body: JSON.stringify(formData),
        signal: controller.signal,
        mode: 'cors',
      });

      clearTimeout(timeoutId);
      const data = await response.json();

      if (data.success) {
        localStorage.setItem('authToken', 'true');
        localStorage.setItem('userId', data.data.userId);
        localStorage.setItem('username', data.data.username);
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('authMethod', 'traditional');

        navigate('/admin-dashboard');
      } else {
        setError(data.message || 'Login failed. Please check your credentials.');
      }
    } catch (err) {
      clearTimeout(timeoutId);
      if (err.name === 'AbortError') {
        setError('Request timed out. Please try again.');
      } else {
        console.error('Login error:', err);
        setError('Network error or server unavailable. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    setGoogleLoading(true);

    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // ✅ Check if email is in the allowed list BEFORE proceeding
      if (!ALLOWED_GOOGLE_EMAILS.includes(user.email?.toLowerCase())) {
        await auth.signOut(); // Sign them out of Firebase immediately
        setError('Access denied. Your Google account is not authorized to access this dashboard.');
        setGoogleLoading(false);
        return;
      }

      // Get Firebase ID token
      const idToken = await user.getIdToken();

      // Verify token with backend
      const response = await fetch(`${API_URL}/api/auth/verify-firebase`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ idToken }),
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('authToken', 'true');
        localStorage.setItem('userId', data.uid);
        localStorage.setItem('username', data.displayName || data.email);
        localStorage.setItem('userEmail', data.email);
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('authMethod', 'google');

        navigate('/admin-dashboard');
      } else {
        setError('Google authentication failed. Please try again.');
      }
    } catch (err) {
      console.error('Google login error:', err);

      if (err.code === 'auth/popup-closed-by-user') {
        setError('Sign-in cancelled. Please try again.');
      } else if (err.code === 'auth/popup-blocked') {
        setError('Pop-up blocked. Please allow pop-ups and try again.');
      } else {
        setError('Google sign-in failed. Please try again.');
      }
    } finally {
      setGoogleLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F1419 0%, #1A1F2E 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'clamp(1rem, 3vw, 2rem)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative Background */}
      <div style={{
        position: 'absolute',
        top: '-10%',
        right: '-10%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(199, 179, 129, 0.08) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-10%',
        left: '-10%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(199, 179, 129, 0.05) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>

      {/* Login Card */}
      <div style={{
        width: '100%',
        maxWidth: '480px',
        background: 'rgba(15, 20, 25, 0.95)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(199, 179, 129, 0.2)',
        borderRadius: '16px',
        padding: isMobile ? 'clamp(2rem, 5vw, 3rem)' : 'clamp(2.5rem, 5vw, 3.5rem)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Logo & Title */}
        <div style={{ textAlign: 'center', marginBottom: 'clamp(2rem, 4vw, 3rem)' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
            <img
              src={logo}
              alt="ST Motors Logo"
              style={{
                height: 'clamp(60px, 10vw, 80px)',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </Link>
          <h1 style={{
            fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
            fontWeight: '300',
            color: '#FFFFFF',
            marginBottom: '0.5rem',
            letterSpacing: '-0.01em'
          }}>
            Welcome <span style={{ fontWeight: '600', color: '#C7B381' }}>Back</span>
          </h1>
          <p style={{
            fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
            color: '#B8B8B8',
            fontWeight: '300'
          }}>
            Sign in to access your dashboard
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div style={{
            background: 'rgba(220, 53, 69, 0.1)',
            border: '1px solid rgba(220, 53, 69, 0.3)',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '1.5rem',
            color: '#ff6b6b',
            fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {/* Google Sign-In Button */}
        <button
          onClick={handleGoogleLogin}
          disabled={googleLoading || loading}
          style={{
            width: '100%',
            padding: 'clamp(1rem, 2vw, 1.25rem)',
            background: '#FFFFFF',
            color: '#1A1F2E',
            border: '1px solid rgba(199, 179, 129, 0.2)',
            borderRadius: '8px',
            fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
            fontWeight: '600',
            cursor: googleLoading || loading ? 'not-allowed' : 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75rem',
            marginBottom: '1.5rem',
            opacity: googleLoading || loading ? 0.6 : 1
          }}
          onMouseEnter={(e) => {
            if (!googleLoading && !loading) {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
            }
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
          }}
        >
          {googleLoading ? (
            'Signing in...'
          ) : (
            <>
              <svg width="20" height="20" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continue with Google
            </>
          )}
        </button>

        {/* Divider */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginBottom: '1.5rem'
        }}>
          <div style={{ flex: 1, height: '1px', background: 'rgba(199, 179, 129, 0.2)' }}></div>
          <span style={{ fontSize: 'clamp(0.8rem, 1.6vw, 0.85rem)', color: '#808080', fontWeight: '500' }}>
            OR
          </span>
          <div style={{ flex: 1, height: '1px', background: 'rgba(199, 179, 129, 0.2)' }}></div>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit}>
          {/* Username Field */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
              color: '#C7B381',
              marginBottom: '0.5rem',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase'
            }}>
              Username
            </label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter username"
              autoComplete="username"
              required
              disabled={loading || googleLoading}
              style={{
                width: '100%',
                padding: 'clamp(0.9rem, 2vw, 1.1rem)',
                background: 'rgba(26, 31, 46, 0.6)',
                border: '1px solid rgba(199, 179, 129, 0.2)',
                borderRadius: '8px',
                fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                color: '#FFFFFF',
                outline: 'none',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit',
                opacity: loading || googleLoading ? 0.6 : 1
              }}
              onFocus={(e) => {
                if (!loading && !googleLoading) {
                  e.target.style.borderColor = '#C7B381';
                  e.target.style.background = 'rgba(26, 31, 46, 0.8)';
                }
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                e.target.style.background = 'rgba(26, 31, 46, 0.6)';
              }}
            />
          </div>

          {/* Password Field */}
          <div style={{ marginBottom: '2rem' }}>
            <label style={{
              display: 'block',
              fontSize: 'clamp(0.85rem, 1.7vw, 0.9rem)',
              color: '#C7B381',
              marginBottom: '0.5rem',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase'
            }}>
              Password
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
                autoComplete="current-password"
                required
                disabled={loading || googleLoading}
                style={{
                  width: '100%',
                  padding: 'clamp(0.9rem, 2vw, 1.1rem)',
                  paddingRight: '3rem',
                  background: 'rgba(26, 31, 46, 0.6)',
                  border: '1px solid rgba(199, 179, 129, 0.2)',
                  borderRadius: '8px',
                  fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                  color: '#FFFFFF',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  fontFamily: 'inherit',
                  opacity: loading || googleLoading ? 0.6 : 1
                }}
                onFocus={(e) => {
                  if (!loading && !googleLoading) {
                    e.target.style.borderColor = '#C7B381';
                    e.target.style.background = 'rgba(26, 31, 46, 0.8)';
                  }
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(199, 179, 129, 0.2)';
                  e.target.style.background = 'rgba(26, 31, 46, 0.6)';
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading || googleLoading}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                style={{
                  position: 'absolute',
                  right: '1rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#C7B381',
                  cursor: loading || googleLoading ? 'not-allowed' : 'pointer',
                  fontSize: '1.2rem',
                  opacity: loading || googleLoading ? 0.6 : 1
                }}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading || googleLoading}
            style={{
              width: '100%',
              padding: 'clamp(1rem, 2vw, 1.25rem)',
              background: loading || googleLoading ? 'rgba(199, 179, 129, 0.5)' : 'linear-gradient(135deg, #C7B381 0%, #A89968 100%)',
              color: '#0F1419',
              border: 'none',
              borderRadius: '8px',
              fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
              fontWeight: '600',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: loading || googleLoading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 16px rgba(199, 179, 129, 0.3)'
            }}
            onMouseEnter={(e) => {
              if (!loading && !googleLoading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(199, 179, 129, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 16px rgba(199, 179, 129, 0.3)';
            }}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginScreen;